import React from 'react';

function Footer() {
    return (
        <div class="footer"><p1 id="footertext">©CyberSentio 2021</p1></div>
    );
}

export default Footer;